import type { SVGProps } from "react";
import type { FC } from 'react';
import styled from 'styled-components';
import { iconSizeMap } from '../utils/size-map';
import type { IconSize, TokenSizeProps } from '../utils/type';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<TokenSizeProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M5.889 8.924a1.5 1.5 0 0 1 2.12 0l.605.605a7 7 0 0 0-1.07 1.758l-.595-.595-4.242 4.243a1 1 0 1 1-1.414-1.414zM13.999 11c.53 0 1.025.138 1.456.378l-2.849 2.85c-.42.42-1.024.536-1.55.355a2.983 2.983 0 0 1 .416-2.196l.074.073 1.166-1.167c.39-.186.826-.293 1.288-.293m7-8a1.5 1.5 0 0 1 1.5 1.5V8a1 1 0 0 1-2 0V6.334l-2.17 2.17a7 7 0 0 0-1.798-1.03L19.006 5H17.5a1 1 0 1 1 0-2z" /><path fill="currentColor" d="M18 14a4 4 0 1 0-8 0 4 4 0 0 0 8 0m2 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0M5.889 8.924a1.5 1.5 0 0 1 2.12 0l.605.605a7 7 0 0 0-1.07 1.758l-.595-.595-4.242 4.243a1 1 0 1 1-1.414-1.414zM20.999 3a1.5 1.5 0 0 1 1.5 1.5V8a1 1 0 0 1-2 0V6.334l-2.17 2.17a7 7 0 0 0-1.798-1.03L19.006 5H17.5a1 1 0 1 1 0-2z" /><path fill="currentColor" d="M17.292 17.293a1 1 0 0 1 1.414 0l3 3a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414" /></svg>;
const Wrapper = styled.span<{
  $size?: IconSize;
}>`
  width: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  height: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  display: inline-block;
  vertical-align: middle;
`;
const SvgSearchGraph = ({
  $size,
  ...rest
}: TokenSizeProps) => <Wrapper $size={$size} className="mnd-icon"><SvgBase {...rest} /></Wrapper>;
export default SvgSearchGraph;